<h2 mat-dialog-title>Public Message</h2>

<mat-dialog-content>

   <p>Type a message here that other players will see. For example, that you are injured for a week or two, or
      going out of town until Thanksgiving.... </p>
   <input type="text" style="width: 100%;" maxlength="40" [(ngModel)]="message" />

   <br /><br />
   <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Show Message Until</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="showMessageUntil" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
   </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
   <div style="display:flex; width:100%; justify-content:space-between; align-items:center;">
      <a href="#" (click)="clearReset($event)">Clear/Reset Message</a>
      <span>
         <a href="#" (click)="cancel($event)">Cancel</a>
         &nbsp;&nbsp;
         <button class="" (click)="save()">Save</button>
      </span>
   </div>
</mat-dialog-actions>